<template>
  <div id="app">
      <keep-alive :include="Object.keys($store.getters.keepAlive)">
          <router-view/>
      </keep-alive>

<!--      <router-view v-if="!$route.meta.keepAlive">-->
<!--          &lt;!&ndash; 这里是不被缓存的视图组件，比如 Edit！ &ndash;&gt;-->
<!--      </router-view>-->
  </div>
</template>

<script>
  export default {
    name: 'app',
    methods: {
      checkIsapp(){
        // console.log('app.vue 检查isapp')
        this.$store.dispatch('app/checkIsapp')
      }
    },
    created() {
      // if (window.plus) {
      //   this.checkIsapp()
      // } else {
      //   document.addEventListener('plusready', this.checkIsapp, false)
      // }
    }
  }
</script>

<style lang="less">

  body {
    background-color: #fbf9fe;
  }
</style>
